module.exports = __webpack_public_path__ + "media/images/icons/flags/BA-62a7d3c022a42892b962fcffaa38a07e.svg";